import { Component, OnInit, AfterViewChecked, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  WidgetInstallmentsPlanService,
  InstallmentItem,
  InstallmentsPlanSummary
} from 'src/app/services/widget-installments-plan.service';

@Component({
  selector: 'app-widget-installments-plan',
  templateUrl: './widget-installments-plan.component.html',
  styleUrls: ['./widget-installments-plan.component.css']
})
export class WidgetInstallmentsPlanComponent implements OnInit, AfterViewChecked {

  private lastHeight = 0;

  personId = '';
  token = '';

  person: any = null;
  summary: InstallmentsPlanSummary = {
    total: 0, paid: 0, overdue: 0, pending: 0, totalDebt: 0, totalPenalties: 0
  };
  installments: InstallmentItem[] = [];

  loading = true;
  error = '';
  errorType: 'auth' | 'permission' | 'network' | '' = '';

  // Group by credit
  groupByCredit = false;

  constructor(
    private route: ActivatedRoute,
    private installmentsPlanService: WidgetInstallmentsPlanService,
    private el: ElementRef
  ) {}

  ngAfterViewChecked(): void {
    const h = this.el.nativeElement.scrollHeight;
    if (h > 0 && h !== this.lastHeight) {
      this.lastHeight = h;
      window.parent.postMessage({ type: 'widget-resize', height: h }, '*');
    }
  }

  ngOnInit(): void {
    document.body.style.background = 'transparent';
    document.documentElement.style.background = 'transparent';

    this.personId = this.route.snapshot.paramMap.get('personId') || '';
    this.token = this.route.snapshot.queryParamMap.get('token') || '';

    if (!this.personId || !this.token) {
      this.error = 'Parámetros de autenticación incompletos';
      this.loading = false;
      return;
    }

    this.loadData();
  }

  async loadData(): Promise<void> {
    this.loading = true;
    this.error = '';

    try {
      const result = await this.installmentsPlanService.getInstallmentsPlan(
        this.personId,
        this.token
      );

      if (result.success) {
        this.person = result.data.person;
        this.summary = result.data.summary;
        this.installments = result.data.installments;
      } else {
        this.error = 'No se pudo cargar el plan de cuotas';
      }
    } catch (err: any) {
      const status = err?.status || err?.error?.statusCode;
      const msg = err?.error?.msg || err?.error?.message || err?.message || '';

      if (status === 401 || msg.includes('Token') || msg.includes('jwt') || msg.includes('expired')) {
        this.errorType = 'auth';
        this.error = 'La sesión ha expirado. Regresa al CRM y vuelve a abrir esta vista.';
      } else if (status === 403 || msg.includes('audience') || msg.includes('origin') || msg.includes('Forbidden')) {
        this.errorType = 'permission';
        this.error = 'Acceso denegado. Este widget no tiene permiso para acceder desde este origen.';
      } else if (status === 0 || !navigator.onLine) {
        this.errorType = 'network';
        this.error = 'Sin conexión con el servidor. Verifica tu red e intenta nuevamente.';
      } else {
        this.errorType = 'network';
        this.error = 'No se pudo cargar el plan de cuotas. Intenta nuevamente.';
      }
    } finally {
      this.loading = false;
    }
  }

  formatCurrency(value: number): string {
    if (value == null) return '$0.00';
    return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  formatDate(dateStr: string | null): string {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    return d.toLocaleDateString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'PAID': return 'Pagada';
      case 'OVERDUE': return 'Vencida';
      case 'PENDING': return 'Pendiente';
      default: return status;
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'PAID': return 'status-paid';
      case 'OVERDUE': return 'status-overdue';
      case 'PENDING': return 'status-pending';
      default: return '';
    }
  }

  retry(): void {
    this.loadData();
  }
}
